import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, DotSeparator, Stack, Typography, TypographyType } from '@lyearn/ui';

import getSmallJobStatusItemConfig from './config';
import { SmallJobStatusItemProps } from './types';

const TYPOGRAPHY_PROPS: TypographyType = { color: 'text-text-secondary', variant: 'body-short-03' };
const CLASSNAME =
  'px-12 h-64 bg-bg-primary max-w-full rounded-8 cursor-pointer border border-border shadow-01';

function SmallJobStatusItem(props: SmallJobStatusItemProps) {
  const { className, title, jobStatus, onCancel, onDownloadReport } = props;
  const { t } = useTranslation();
  const [isHovered, { on, off }] = useToggle(false);
  const { descriptionKey, descriptionAction, Icon, iconClassName, rightNode } =
    getSmallJobStatusItemConfig({ t, isHovered, onCancel, onDownloadReport })[jobStatus];

  return (
    <Box className={className}>
      <Stack alignItems="center" className={CLASSNAME} onMouseEnter={on} onMouseLeave={off}>
        <Icon className={cn('h-24 w-20', iconClassName)} />
        <Stack className="min-w-0 flex-1 ms-12 me-40" direction="col">
          <Typography className="truncate" color="text-text-primary" variant="body-short-02">
            {title}
          </Typography>
          <DotSeparator gapX={6} typographyProps={TYPOGRAPHY_PROPS}>
            <Typography
              className="flex-shrink-0"
              color="text-text-secondary"
              variant="body-short-03">
              {t(descriptionKey)}
            </Typography>
            {descriptionAction}
          </DotSeparator>
        </Stack>
        {rightNode}
      </Stack>
    </Box>
  );
}

export default SmallJobStatusItem;
